<template>
    <div class="family-center">
        <div class="map" id="mapContainer" ref="map"></div>
        <div class="map-carousel">
            <p id="title">我们的幼儿园</p>
            <div class="map-carousel-wrapper">
                <ul ref="carouselUl">
                    <li class="item" v-for="(item,index) in school" :key="index">
                        <div class="item-garden">
                          <template v-if="item.href">
                            <a target="_blank" :href="item.href">
                              <div class="imgbg">
                                <img id="code" :src="item.code">
                                <img id="pic" :src="item.pic">
                                </div>
                                <p class="name">{{item.name}}</p>
                                <p><img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/family_icon_phone.png" /></i><span>{{item.phone}}</span></p>
                                <p><img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/family_icon_address.png" /></i><span class="blockSpan">{{item.addr}}</span></p>
                            </a>
                          </template>
                          <template v-else>
                            <a @click="showMaintance">
                            <div class="imgbg">
                                <img id="code" :src="item.code">
                                <img id="pic" :src="item.pic">
                                </div>
                                <p class="name">{{item.name}}</p>
                                <p><img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/family_icon_phone.png" /></i><span>{{item.phone}}</span></p>
                                <p><img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/family_icon_address.png" /></i><span class="blockSpan">{{item.addr}}</span></p>
                                </a>
                          </template>
                        </div>
                    </li>
                </ul>
            </div>
            <span class="button-last"  @click.stop="clickLast">&#xe66d;</span>
            <span class="button-next"  @click.stop="clickNext">&#xe66e;</span>
		</div>
    </div>
</template>

<script>
import 'echarts/map/js/china.js'
import mapData from '../../../static/mock/map.json'
export default {
  name: '',
  data () {
    return {
      school: [],
      provinces: [],
      myChart: {},
      page: 1
    }
  },
  watch: {
  },
  mounted () {
    this.$nextTick(() => {
      this.getSchools()
    })
  },
  methods: {
    getSchools () {
      let param = {}
      mapData.data.forEach(item => {
        this.provinces.push({
          name: item.name,
          value: item.value,
          schools: item.schools,
          code: item.code,
          pic: item.pic,
          isShow: false
        })
      })
      if (this.$store.state.isMobile) {
        this.school = mapData.listAll
      } else {
        this.school = mapData.list
      }

      this.drawChinaMap()
    },
    drawChinaMap () {
      let that_ = this
      that_.myChart = this.$echarts.init(
        document.getElementById('mapContainer')
      )
      var option = {
        tooltip: {
          trigger: 'item',
          show: false
        },
        dataRange: {
          show: false,
          min: 0,
          max: 2,
          x: 'left',
          y: 'bottom',
          text: ['高', '低'],
          calculable: true,
          inRange: {
            color: ['#f6f1e1', '#debd77', '#c49938']
          }
        },
        series: [
          {
            name: 'schools',
            type: 'map',
            mapType: 'china',
            zoom: 1.2,
            roam: false,
            itemStyle: {
              normal: {
                areaColor: '#f8f3e3',
                borderColor: '#debd77',
                borderWidth: '1'
              }
              // emphasis:{
              //   areaColor:'#ffdce0',
              // borderColor:'#f72452',
              // borderWidth:'1'
              // },
            },
            data: that_.provinces
          }
        ]
      }
      that_.myChart.setOption(option)
    },
    clickNext () {
      this.getSchools()
      if (this.page == 1) {
        this.school = mapData.list2
        this.page = 2
      } else if (this.page == 2) {
        this.school = mapData.list
        this.page = 1
      }
    },
    clickLast () {
      this.getSchools()
      if (this.page == 2) {
        this.school = mapData.list
        this.page = 1
      } else if (this.page == 1) {
        this.school = mapData.list2
        this.page = 2
      }
    },
    showMaintance () {
      this.$message({
        message: '主页君正在努力中，敬请期待……',
        offset: window.screen.height / 3,
        iconClass: 'icon-custom',
        duration: 1500
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.icon-custom{

}
.family-center {
  position: relative;
  .map-carousel {
    position: relative;
    width: 1200px;
    height: 818px;
    background: #f6f6f6;
    -webkit-box-shadow: 0px 2px 10px 0px rgba(202, 202, 202, 0.5);
    box-shadow: 0px 2px 10px 0px rgba(202, 202, 202, 0.5);
    // top: 210px;
    // left: 50%;
    margin: 0 auto;
    margin-bottom: 50px;
    #title {
      width: 100%;
      height: 23px;
      font-size: 24px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      padding-bottom: 23px;
      padding-top: 59px;
    }
    .map-carousel-wrapper {
      position: absolute;
      left: 183px;
      right: 183px;
      top: 105px;
      bottom: 45px;
      overflow: hidden;
      ul {
        transition: all 0.2s ease-in-out;
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        align-items: center;
        // justify-content: space-around;
        overflow: hidden;
        width: 100%;
        li.item {
          margin: 0 9px;
          display: flex;
          display: -webkit-flex;
          float: left;
          width: 260px;
          height: 322px;
          background: rgba(255, 255, 255, 1);
          border-radius: 6px;
          margin-bottom: 20px;
          position: relative;
          div.item-garden {
            padding: 10px 10px 0 10px;
            a {
              display: block;
              width: 100%;
              height: 100%;
            }
            .imgbg {
              width: 240px;
              height: 150px;
              background: rgba(174, 149, 79, 1);
              text-align: center;
              cursor: pointer;
              #code {
                width: 100px;
                height: 100px;
                margin-top: 25px;
              }
              #pic{
                 width: 240px;
                 height: 150px;
                 position: absolute;
                 top: 10px;
                 left: 10px;
              }
            }
            .imgbg:hover #pic{
                display: none;
            }
            p {
              padding-bottom: 10px;
              img {
                width: 20px;
                height: 20px;
                float: left;
                margin-right: 5px;
              }
              span {
                line-height: 20px;
                font-size: 14px;
                font-family: PingFangSC-Regular;
                color: rgba(102, 102, 102, 1);
              }
              span.blockSpan {
                display: inline-block;
                width: 210px;
                vertical-align: text-top;
              }
              i.icon {
                background-size: 20px;
                background-repeat: no-repeat;
                padding-right: 9px;
                padding-left: 20px;
              }
            }
            p.name {
              box-sizing: content-box;
              padding-top: 18px;
              padding-bottom: 30px;
              height: 23px;
              font-size: 24px;
              font-family: PingFangSC-Regular;
              color: rgba(51, 51, 51, 1);
              line-height: 36px;
            }
          }
        }
      }
    }
    .clz {
      position: absolute;
      top: 25px;
      right: 30px;
      width: 19px;
      height: 19px;
      background: url("../../assets/image/close.png") no-repeat;
      background-size: 19px;
      cursor: pointer;
    }
    .button-last {
      position: absolute;
      left: 78px;
      top: 421px;
      width: 32px;
      height: 32px;
      font-family: "iconfont" !important;
      font-size: 32px;
      color: rgba(174, 149, 79, 1);
      cursor: pointer;
    }
    .button-next {
      position: absolute;
      right: 78px;
      top: 421px;
      width: 32px;
      height: 32px;
      font-family: "iconfont" !important;
      font-size: 32px;
      color: rgba(174, 149, 79, 1);
      cursor: pointer;
    }
  }
}
@media (max-width: 767px) {
  .family-center {
    position: relative;
    .map {
      width: 340px;
      height: 280px;
      margin: 0;
      padding-left: 4.4%;
      margin-bottom: 30px;
    }
    .map-carousel {
      position: relative;
      width: 100%;
      height: 1905px;
      margin: 0 auto;
      margin-bottom: 50px;
      #title {
        width: 100%;
        height: 23px;
        font-size: 21px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        text-align: center;
        padding-bottom: 23px;
        padding-top: 59px;
      }
      .map-carousel-wrapper {
        width: 100%;
        left: 0;
        top: 105px;
        ul {
          transition: all 0.2s ease-in-out;
          display: flex;
          display: -webkit-flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          overflow: hidden;
          width: 100%;
          padding: 0 3%;
          box-sizing: border-box;
          li.item {
            display: flex;
            display: -webkit-flex;
            flex-wrap: wrap;
            float: left;
            width: 48%;
            height: 244px;
            margin: 0;
            margin-bottom: 10px;
            div.item-garden {
              width: 100%;
              box-sizing: border-box;
              padding: 10px 6px 0 6px;
              .imgbg {
                width: 100%;
                height: 98px;
                #code {
                  width: 80px;
                  height: 80px;
                  margin-top: 9px;
                }
                #pic{
                  width: 94%;
                  height: auto;
                  position: absolute;
                  top: 10px;
                  left: 6px;
                }
              }
              .imgbg:hover #pic{
                  display: none;
              }
              p {
                padding-bottom: 10px;
                display: flex;
                img {
                  width: 15px;
                  height: 15px;
                  margin-right: 3px;
                }
                span {
                  flex: 1;
                  line-height: 15px;
                  font-size: 12px;
                }
              }
              p.name {
                box-sizing: content-box;
                padding-top: 18px;
                padding-bottom: 15px;
                height: 24px;
                font-size: 18px;
                line-height: 24px;
              }
            }
          }
        }
      }
      .button-last {
        display: none;
      }
      .button-next {
        display: none;
      }
    }
  }
}
@media (min-width: 376px) and (max-width: 414px) {
  .family-center {
    position: relative;
    .map {
      width: 370px;
      margin-bottom: 40px;
    }
    .map-carousel {
      height: 2005px;
      #title {
        padding-bottom: 23px;
        padding-top: 59px;
      }
      .map-carousel-wrapper {
        ul {
          li.item {
            height: 256px;
            div.item-garden {
              .imgbg {
                height: 108px;
                #code {
                  width: 96px;
                  height: 96px;
                  margin-top: 6px;
                }
              }
            }
          }
          li:nth-child(5), li:last-child {
            div.item-garden {
              .imgbg {
                height: 104px;
                #code {
                  margin-top: 4px;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media (min-width: 321px) and (max-width: 360px) {
  .family-center {
    .map {
      width: 330px;
      margin-bottom: 40px;
    }
    .map-carousel {
      height: 1935px;
      .map-carousel-wrapper {
        ul {
          li.item {
            height: 245px;
            div.item-garden {
              .imgbg {
                height: 95px;
                #code {
                  width: 88px;
                  height: 88px;
                  margin-top: 4px;
                }
                #pc {
                  width: 93%;
                }
              }
            }
          }
          li:nth-child(5), li:last-child {
            div.item-garden {
              .imgbg {
                height: 91px;
                #code {
                  margin-top: 2px;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media (min-width: 320px) and (max-width: 320px) {
  .family-center {
    .map {
      width: 300px;
      margin-bottom: 40px;
    }
    .map-carousel {
      height: 1889px;
      .map-carousel-wrapper {
        ul {
          li.item {
            height: 240px;
            div.item-garden {
              .imgbg {
                height: 84px;
                #code {
                  width: 80px;
                  height: 80px;
                  margin-top: 2px;
                }
                #pc {
                  width: 92%;
                }
              }
            }
          }
          li:nth-child(5), li:last-child {
            div.item-garden {
              .imgbg {
                height: 81px;
                #code {
                  width: 76px;
                  height: 76px;
                  margin-top: 2px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/kindergarten/map.vue